import { IconName } from './Icon.types'
import align_bottom from '~assets/icons/align_bottom.svg'
import align_center_hor from '~assets/icons/align_center_hor.svg'
import align_center_vert from '~assets/icons/align_center_vert.svg'
import align_left from '~assets/icons/align_left.svg'
import align_right from '~assets/icons/align_right.svg'
import align_top from '~assets/icons/align_top.svg'
import areachart from '~assets/icons/areachart.svg'
import archive from '~assets/icons/archive.svg'
import arrow_curved_down_to_tray from '~assets/icons/arrow_curved_down_to_tray.svg'
import arrow_curved_up_to_tray from '~assets/icons/arrow_curved_up_to_tray.svg'
import arrow_down from '~assets/icons/arrow_down.svg'
import arrow_down_to_line from '~assets/icons/arrow_down_to_line.svg'
import arrow_left from '~assets/icons/arrow_left.svg'
import arrow_long_right from '~assets/icons/arrow_long_right.svg'
import arrow_right from '~assets/icons/arrow_right.svg'
import arrow_small_down from '~assets/icons/arrow_small_down.svg'
import arrow_small_up from '~assets/icons/arrow_small_up.svg'
import arrow_up from '~assets/icons/arrow_up.svg'
import arrow_u_turn_left from '~assets/icons/arrow_u_turn_left.svg'
import arrow_u_turn_right from '~assets/icons/arrow_u_turn_right.svg'
import arrows_bidirectional from '~assets/icons/arrows_bidirectional.svg'
import arrows_up_and_down from '~assets/icons/arrows_up_and_down.svg'
import attachment from '~assets/icons/attachment.svg'
import bar_chart from '~assets/icons/barchart.svg'
import bell from '~assets/icons/bell.svg'
import bell_slash from '~assets/icons/bell_slash.svg'
import bell_z from '~assets/icons/bell_z.svg'
import bolt from '~assets/icons/bolt.svg'
import box from '~assets/icons/box.svg'
import book from '~assets/icons/book.svg'
import bookmark from '~assets/icons/bookmark.svg'
import bookmark_outlined from '~assets/icons/bookmark_outlined.svg'
import box_arrow_down from '~assets/icons/box_arrow_down.svg'
import box_arrow_up from '~assets/icons/box_arrow_up.svg'
import branch from '~assets/icons/branch.svg'
import branches from '~assets/icons/branches.svg'
import brand_colored_ethereum from '~assets/icons/brand_colored_ethereum.svg'
import brand_colored_hacera from '~assets/icons/brand_colored_hacera.svg'
import brand_colored_mipasa from '~assets/icons/brand_colored_mipasa.svg'
import brand_colored_papillon from '~assets/icons/brand_colored_papillon.svg'
import brand_colored_unwallet from '~assets/icons/brand_colored_unwallet.svg'
import brand_colored_coq from '~assets/icons/brand_colored_coq.svg'
import brand_colored_github from '~assets/icons/brand_colored_github.svg'
import brand_colored_golang from '~assets/icons/brand_colored_golang.svg'
import brand_colored_haskell from '~assets/icons/brand_colored_haskell.svg'
import brand_colored_k from '~assets/icons/brand_colored_k.svg'
import brand_colored_python from '~assets/icons/brand_colored_python.svg'
import brand_colored_rust from '~assets/icons/brand_colored_rust.svg'
import brand_colored_solidity from '~assets/icons/brand_colored_solidity.svg'
import brand_ethereum from '~assets/icons/brand_ethereum.svg'
import brand_ethereum_arrow from '~assets/icons/brand_ethereum_arrow.svg'
import brand_etherscan from '~assets/icons/brand_etherscan.svg'
import brand_facebook from '~assets/icons/brand_facebook.svg'
import brand_github from '~assets/icons/brand_github.svg'
import brand_gitlab from '~assets/icons/brand_gitlab.svg'
import brand_google from '~assets/icons/brand_google.svg'
import brand_linkedin from '~assets/icons/brand_linkedin.svg'
import brand_solidity from '~assets/icons/brand_solidity.svg'
import brand_twitter from '~assets/icons/brand_twitter.svg'
import brand_unbounded from '~assets/icons/brand_unbounded.svg'
import brand_wallet_connect from '~assets/icons/brand_wallet_connect.svg'
import brand_squared_discord from '~assets/icons/brand_squared_discord.svg'
import brand_squared_facebook from '~assets/icons/brand_squared_facebook.svg'
import brand_squared_linkedin from '~assets/icons/brand_squared_linkedin.svg'
import brand_squared_medium from '~assets/icons/brand_squared_medium.svg'
import brand_squared_reddit from '~assets/icons/brand_squared_reddit.svg'
import brand_squared_twitter from '~assets/icons/brand_squared_twitter.svg'
import brand_squared_youtube from '~assets/icons/brand_squared_youtube.svg'
import bubble from '~assets/icons/bubble.svg'
import calculator from '~assets/icons/calculator.svg'
import calendar from '~assets/icons/calendar.svg'
import calendar_bolt from '~assets/icons/calendar_bolt.svg'
import calendar_check from '~assets/icons/calendar_check.svg'
import calendar_clock from '~assets/icons/calendar_clock.svg'
import calendar_exclamation from '~assets/icons/calendar_exclamation.svg'
import calendar_pencil from '~assets/icons/calendar_pencil.svg'
import calendar_plus from '~assets/icons/calendar_plus.svg'
import calendar_star from '~assets/icons/calendar_star.svg'
import calendar_times from '~assets/icons/calendar_times.svg'
import cancel from '~assets/icons/cancel.svg'
import cell_plus_down from '~assets/icons/cell_plus_down.svg'
import cell_plus_up from '~assets/icons/cell_plus_up.svg'
import chat_bubble from '~assets/icons/chat_bubble.svg'
import chart_line from '~assets/icons/chart_line.svg'
import chart_bar from '~assets/icons/chart_bar.svg'
import chart_area from '~assets/icons/chart_area.svg'
import chart_point from '~assets/icons/chart_point.svg'
import check from '~assets/icons/check.svg'
import chevron_down from '~assets/icons/chevron_down.svg'
import chevron_left from '~assets/icons/chevron_left.svg'
import chevron_right from '~assets/icons/chevron_right.svg'
import chevron_up from '~assets/icons/chevron_up.svg'
import chevron_up_and_down from '~assets/icons/chevron_up_and_down.svg'
import circle from '~assets/icons/circle.svg'
import circle_3dots from '~assets/icons/circle_3dots.svg'
import circle_arrow_down from '~assets/icons/circle_arrow_down.svg'
import circle_arrow_left from '~assets/icons/circle_arrow_left.svg'
import circle_arrow_right from '~assets/icons/circle_arrow_right.svg'
import circle_arrow_up from '~assets/icons/circle_arrow_up.svg'
import circle_check from '~assets/icons/circle_check.svg'
import circle_chevron_down from '~assets/icons/circle_chevron_down.svg'
import circle_chevron_left from '~assets/icons/circle_chevron_left.svg'
import circle_chevron_right from '~assets/icons/circle_chevron_right.svg'
import circle_chevron_up from '~assets/icons/circle_chevron_up.svg'
import circle_exclamation from '~assets/icons/circle_exclamation.svg'
import circle_info from '~assets/icons/circle_info.svg'
import circle_play from '~assets/icons/circle_play.svg'
import circle_plus from '~assets/icons/circle_plus.svg'
import circle_question from '~assets/icons/circle_question.svg'
import circle_stop from '~assets/icons/circle_stop.svg'
import circle_times from '~assets/icons/circle_times.svg'
import circle_user from '~assets/icons/circle_user.svg'
import clap from '~assets/icons/clap.svg'
import clapped from '~assets/icons/clapped.svg'
import clock from '~assets/icons/clock.svg'
import clock_reversed from '~assets/icons/clock_reversed.svg'
import cloud_arrow_down from '~assets/icons/cloud_arrow_down.svg'
import cloud_arrow_in from '~assets/icons/cloud_arrow_in.svg'
import cloud_arrow_up from '~assets/icons/cloud_arrow_up.svg'
import cloud_check from '~assets/icons/cloud_check.svg'
import code from '~assets/icons/code.svg'
import cog from '~assets/icons/cog.svg'
import compass from '~assets/icons/compass.svg'
import confetti from '~assets/icons/confetti.svg'
import config from '~assets/icons/config.svg'
import connection from '~assets/icons/connection.svg'
import connection_slash from '~assets/icons/connection_slash.svg'
import console from '~assets/icons/console.svg'
import console_check from '~assets/icons/console_check.svg'
import color_picker from '~assets/icons/color_picker.svg'
import copy from '~assets/icons/copy.svg'
import copy_plus from '~assets/icons/copy_plus.svg'
import data from '~assets/icons/data.svg'
import description from '~assets/icons/description.svg'
import dog from '~assets/icons/dog.svg'
import door_in from '~assets/icons/door_in.svg'
import door_out from '~assets/icons/door_out.svg'
import dots_horizontal from '~assets/icons/dots_horizontal.svg'
import dots_vertical from '~assets/icons/dots_vertical.svg'
import dots_vertical_6 from '~assets/icons/dots_vertical_6.svg'
import dots_vertical_9 from '~assets/icons/dots_vertical_9.svg'
import embed from '~assets/icons/embed.svg'
import empty from '~assets/icons/empty.svg'
import exclamation from '~assets/icons/exclamation.svg'
import exclamation_triangle from '~assets/icons/exclamation_triangle.svg'
import eye from '~assets/icons/eye.svg'
import eye_slash from '~assets/icons/eye_slash.svg'
import file from '~assets/icons/file.svg'
import file_check from '~assets/icons/file_check.svg'
import file_data from '~assets/icons/file_data.svg'
import file_eye from '~assets/icons/file_eye.svg'
import file_plus from '~assets/icons/file_plus.svg'
import file_times from '~assets/icons/file_times.svg'
import filter from '~assets/icons/filter.svg'
import flag from '~assets/icons/flag.svg'
import folder from '~assets/icons/folder.svg'
import folder_arrow_down from '~assets/icons/folder_arrow_down.svg'
import folder_arrow_up from '~assets/icons/folder_arrow_up.svg'
import folder_check from '~assets/icons/folder_check.svg'
import folder_minus from '~assets/icons/folder_minus.svg'
import folder_plus from '~assets/icons/folder_plus.svg'
import folder_times from '~assets/icons/folder_times.svg'
import full_name from '~assets/icons/full_name.svg'
import globe from '~assets/icons/globe.svg'
import googles from '~assets/icons/googles.svg'
import grid from '~assets/icons/grid.svg'
import heart_outlined from '~assets/icons/heart_outlined.svg'
import heartbeat from '~assets/icons/heartbeat.svg'
import horizontal_barchart from '~assets/icons/horizontal_barchart.svg'
import key_horizontal from '~assets/icons/key_horizontal.svg'
import key_vertical from '~assets/icons/key_vertical.svg'
import keyboard from '~assets/icons/keyboard.svg'
import lamp from '~assets/icons/lamp.svg'
import layout from '~assets/icons/layout.svg'
import link from '~assets/icons/link.svg'
import list from '~assets/icons/list.svg'
import lock from '~assets/icons/lock.svg'
import lock_opened from '~assets/icons/lock_opened.svg'
import magic_wand from '~assets/icons/magic_wand.svg'
import mail from '~assets/icons/mail.svg'
import menu from '~assets/icons/menu.svg'
import microscope from '~assets/icons/microscope.svg'
import minus from '~assets/icons/minus.svg'
import multi_select from '~assets/icons/multi_select.svg'
import network from '~assets/icons/network.svg'
import newsroom from '~assets/icons/newsroom.svg'
import notebook from '~assets/icons/notebook.svg'
import notebook_arrow_up from '~assets/icons/notebook_arrow_up.svg'
import panes_horizontal from '~assets/icons/panes_horizontal.svg'
import panes_vertical from '~assets/icons/panes_vertical.svg'
import paper_plane from '~assets/icons/paper_plane.svg'
import paragraph from '~assets/icons/paragraph.svg'
import pause from '~assets/icons/pause.svg'
import pencil from '~assets/icons/pencil.svg'
import pencil_check from '~assets/icons/pencil_check.svg'
import picture from '~assets/icons/picture.svg'
import picture_light from '~assets/icons/picture_light.svg'
import pictures from '~assets/icons/pictures.svg'
import pie_chart from '~assets/icons/pie_chart.svg'
import pin from '~assets/icons/pin.svg'
import pin_outlined from '~assets/icons/pin_outlined.svg'
import planet from '~assets/icons/planet.svg'
import play from '~assets/icons/play.svg'
import plug_connecting from '~assets/icons/plug_connecting.svg'
import plugin from '~assets/icons/plugin.svg'
import plus from '~assets/icons/plus.svg'
import poll from '~assets/icons/poll.svg'
import preview from '~assets/icons/preview.svg'
import preview2 from '~assets/icons/preview2.svg'
import puzzle_piece from '~assets/icons/puzzle_piece.svg'
import radio_btn from '~assets/icons/radio_btn.svg'
import refresh from '~assets/icons/refresh.svg'
import repeat from '~assets/icons/repeat.svg'
import reply from '~assets/icons/reply.svg'
import reverse from '~assets/icons/reverse.svg'
import rhombus from '~assets/icons/rhombus.svg'
import rocket from '~assets/icons/rocket.svg'
import rows from '~assets/icons/rows.svg'
import save from '~assets/icons/save.svg'
import screen_stats from '~assets/icons/screen_stats.svg'
import search from '~assets/icons/search.svg'
import search_eye from '~assets/icons/search_eye.svg'
import search_left from '~assets/icons/search_left.svg'
import separator from '~assets/icons/separator.svg'
import settings from '~assets/icons/settings.svg'
import share from '~assets/icons/share.svg'
import sidebar from '~assets/icons/sidebar.svg'
import slider from '~assets/icons/slider.svg'
import socket from '~assets/icons/socket.svg'
import sort_descending from '~assets/icons/sort_descending.svg'
import spinner from '~assets/icons/spinner.svg'
import square_arrow_down_to_line from '~assets/icons/square_arrow_down_to_line.svg'
import square_arrows from '~assets/icons/square_arrows.svg'
import square_chevron_down from '~assets/icons/square_chevron_down.svg'
import square_chevron_up from '~assets/icons/square_chevron_up.svg'
import square_code from '~assets/icons/square_code.svg'
import square_exclamation from '~assets/icons/square_exclamation.svg'
import square_hash from '~assets/icons/square_hash.svg'
import square_info from '~assets/icons/square_info.svg'
import square_lego from '~assets/icons/square_lego.svg'
import square_markdown from '~assets/icons/square_markdown.svg'
import square_minus from '~assets/icons/square_minus.svg'
import square_number from '~assets/icons/square_number.svg'
import square_play from '~assets/icons/square_play.svg'
import square_plus from '~assets/icons/square_plus.svg'
import square_restart from '~assets/icons/square_restart.svg'
import square_run_all from '~assets/icons/square_run_all.svg'
import square_save from '~assets/icons/square_save.svg'
import square_stop from '~assets/icons/square_stop.svg'
import square_text from '~assets/icons/square_text.svg'
import square_times from '~assets/icons/square_times.svg'
import stacked_areachart from '~assets/icons/stacked_areachart.svg'
import star_outlined from '~assets/icons/star_outlined.svg'
import stop from '~assets/icons/stop.svg'
import tag from '~assets/icons/tag.svg'
import target from '~assets/icons/target.svg'
import telescope from '~assets/icons/telescope.svg'
import text_input from '~assets/icons/text_input.svg'
import thumb_down from '~assets/icons/thumb_down.svg'
import thumb_up from '~assets/icons/thumb_up.svg'
import times from '~assets/icons/times.svg'
import times_small from '~assets/icons/times_small.svg'
import trash from '~assets/icons/trash.svg'
import tray from '~assets/icons/tray.svg'
import tray_full from '~assets/icons/tray_full.svg'
import triple_dots from '~assets/icons/triple_dots.svg'
import user from '~assets/icons/user.svg'
import user_arrow_left from '~assets/icons/user_arrow_left.svg'
import user_arrow_right from '~assets/icons/user_arrow_right.svg'
import user_check from '~assets/icons/user_check.svg'
import user_cog from '~assets/icons/user_cog.svg'
import user_plus from '~assets/icons/user_plus.svg'
import user_search from '~assets/icons/user_search.svg'
import user_star from '~assets/icons/user_star.svg'
import user_times from '~assets/icons/user_times.svg'
import users from '~assets/icons/users.svg'
import users_v2 from '~assets/icons/users_v2.svg'
import wallet from '~assets/icons/wallet.svg'

export const ICON_SMALL_SIZE = 16
export const ICON_MEDIUM_SIZE = 20
export const ICON_LARGE_SIZE = 24

export const ICONS_MAP: Record<IconName, string> = {
  [IconName.align_bottom]: align_bottom,
  [IconName.align_center_hor]: align_center_hor,
  [IconName.align_center_vert]: align_center_vert,
  [IconName.align_left]: align_left,
  [IconName.align_right]: align_right,
  [IconName.align_top]: align_top,
  [IconName.areachart]: areachart,
  [IconName.archive]: archive,
  [IconName.arrow_curved_down_to_tray]: arrow_curved_down_to_tray,
  [IconName.arrow_curved_up_to_tray]: arrow_curved_up_to_tray,
  [IconName.arrow_down]: arrow_down,
  [IconName.arrow_down_to_line]: arrow_down_to_line,
  [IconName.arrow_left]: arrow_left,
  [IconName.arrow_long_right]: arrow_long_right,
  [IconName.arrow_right]: arrow_right,
  [IconName.arrow_small_down]: arrow_small_down,
  [IconName.arrow_small_up]: arrow_small_up,
  [IconName.arrow_up]: arrow_up,
  [IconName.arrow_u_turn_left]: arrow_u_turn_left,
  [IconName.arrow_u_turn_right]: arrow_u_turn_right,
  [IconName.arrows_bidirectional]: arrows_bidirectional,
  [IconName.arrows_up_and_down]: arrows_up_and_down,
  [IconName.attachment]: attachment,
  [IconName.bar_chart]: bar_chart,
  [IconName.bell]: bell,
  [IconName.bell_slash]: bell_slash,
  [IconName.bell_z]: bell_z,
  [IconName.bolt]: bolt,
  [IconName.book]: book,
  [IconName.bookmark]: bookmark,
  [IconName.bookmark_outlined]: bookmark_outlined,
  [IconName.box_arrow_down]: box_arrow_down,
  [IconName.box_arrow_up]: box_arrow_up,
  [IconName.box]: box,
  [IconName.branch]: branch,
  [IconName.branches]: branches,
  [IconName.brand_colored_ethereum]: brand_colored_ethereum,
  [IconName.brand_colored_hacera]: brand_colored_hacera,
  [IconName.brand_colored_mipasa]: brand_colored_mipasa,
  [IconName.brand_colored_papillon]: brand_colored_papillon,
  [IconName.brand_colored_unwallet]: brand_colored_unwallet,
  [IconName.brand_colored_coq]: brand_colored_coq,
  [IconName.brand_colored_github]: brand_colored_github,
  [IconName.brand_colored_golang]: brand_colored_golang,
  [IconName.brand_colored_haskell]: brand_colored_haskell,
  [IconName.brand_colored_k]: brand_colored_k,
  [IconName.brand_colored_python]: brand_colored_python,
  [IconName.brand_colored_rust]: brand_colored_rust,
  [IconName.brand_colored_solidity]: brand_colored_solidity,
  [IconName.brand_ethereum]: brand_ethereum,
  [IconName.brand_ethereum_arrow]: brand_ethereum_arrow,
  [IconName.brand_etherscan]: brand_etherscan,
  [IconName.brand_facebook]: brand_facebook,
  [IconName.brand_github]: brand_github,
  [IconName.brand_gitlab]: brand_gitlab,
  [IconName.brand_google]: brand_google,
  [IconName.brand_linkedin]: brand_linkedin,
  [IconName.brand_solidity]: brand_solidity,
  [IconName.brand_twitter]: brand_twitter,
  [IconName.brand_unbounded]: brand_unbounded,
  [IconName.brand_wallet_connect]: brand_wallet_connect,
  [IconName.brand_squared_discord]: brand_squared_discord,
  [IconName.brand_squared_facebook]: brand_squared_facebook,
  [IconName.brand_squared_linkedin]: brand_squared_linkedin,
  [IconName.brand_squared_medium]: brand_squared_medium,
  [IconName.brand_squared_reddit]: brand_squared_reddit,
  [IconName.brand_squared_twitter]: brand_squared_twitter,
  [IconName.brand_squared_youtube]: brand_squared_youtube,
  [IconName.bubble]: bubble,
  [IconName.calculator]: calculator,
  [IconName.calendar]: calendar,
  [IconName.calendar_bolt]: calendar_bolt,
  [IconName.calendar_check]: calendar_check,
  [IconName.calendar_clock]: calendar_clock,
  [IconName.calendar_exclamation]: calendar_exclamation,
  [IconName.calendar_pencil]: calendar_pencil,
  [IconName.calendar_plus]: calendar_plus,
  [IconName.calendar_star]: calendar_star,
  [IconName.calendar_times]: calendar_times,
  [IconName.cancel]: cancel,
  [IconName.cell_plus_down]: cell_plus_down,
  [IconName.cell_plus_up]: cell_plus_up,
  [IconName.chart_line]: chart_line,
  [IconName.chart_bar]: chart_bar,
  [IconName.chart_area]: chart_area,
  [IconName.chart_point]: chart_point,
  [IconName.chat_bubble]: chat_bubble,
  [IconName.check]: check,
  [IconName.chevron_down]: chevron_down,
  [IconName.chevron_left]: chevron_left,
  [IconName.chevron_right]: chevron_right,
  [IconName.chevron_up]: chevron_up,
  [IconName.chevron_up_and_down]: chevron_up_and_down,
  [IconName.circle]: circle,
  [IconName.circle_3dots]: circle_3dots,
  [IconName.circle_arrow_down]: circle_arrow_down,
  [IconName.circle_arrow_left]: circle_arrow_left,
  [IconName.circle_arrow_right]: circle_arrow_right,
  [IconName.circle_arrow_up]: circle_arrow_up,
  [IconName.circle_check]: circle_check,
  [IconName.circle_chevron_down]: circle_chevron_down,
  [IconName.circle_chevron_left]: circle_chevron_left,
  [IconName.circle_chevron_right]: circle_chevron_right,
  [IconName.circle_chevron_up]: circle_chevron_up,
  [IconName.circle_exclamation]: circle_exclamation,
  [IconName.circle_info]: circle_info,
  [IconName.circle_play]: circle_play,
  [IconName.circle_plus]: circle_plus,
  [IconName.circle_question]: circle_question,
  [IconName.circle_stop]: circle_stop,
  [IconName.circle_times]: circle_times,
  [IconName.circle_user]: circle_user,
  [IconName.clap]: clap,
  [IconName.clapped]: clapped,
  [IconName.clock]: clock,
  [IconName.clock_reversed]: clock_reversed,
  [IconName.cloud_arrow_down]: cloud_arrow_down,
  [IconName.cloud_arrow_in]: cloud_arrow_in,
  [IconName.cloud_arrow_up]: cloud_arrow_up,
  [IconName.cloud_check]: cloud_check,
  [IconName.code]: code,
  [IconName.cog]: cog,
  [IconName.compass]: compass,
  [IconName.confetti]: confetti,
  [IconName.config]: config,
  [IconName.connection]: connection,
  [IconName.connection_slash]: connection_slash,
  [IconName.console]: console,
  [IconName.console_check]: console_check,
  [IconName.color_picker]: color_picker,
  [IconName.copy]: copy,
  [IconName.copy_plus]: copy_plus,
  [IconName.data]: data,
  [IconName.description]: description,
  [IconName.dog]: dog,
  [IconName.door_in]: door_in,
  [IconName.door_out]: door_out,
  [IconName.dots_horizontal]: dots_horizontal,
  [IconName.dots_vertical]: dots_vertical,
  [IconName.dots_vertical_6]: dots_vertical_6,
  [IconName.dots_vertical_9]: dots_vertical_9,
  [IconName.embed]: embed,
  [IconName.empty]: empty,
  [IconName.exclamation]: exclamation,
  [IconName.exclamation_triangle]: exclamation_triangle,
  [IconName.eye]: eye,
  [IconName.eye_slash]: eye_slash,
  [IconName.file]: file,
  [IconName.file_check]: file_check,
  [IconName.file_data]: file_data,
  [IconName.file_eye]: file_eye,
  [IconName.file_plus]: file_plus,
  [IconName.file_times]: file_times,
  [IconName.filter]: filter,
  [IconName.flag]: flag,
  [IconName.folder]: folder,
  [IconName.folder_arrow_down]: folder_arrow_down,
  [IconName.folder_arrow_up]: folder_arrow_up,
  [IconName.folder_check]: folder_check,
  [IconName.folder_minus]: folder_minus,
  [IconName.folder_plus]: folder_plus,
  [IconName.folder_times]: folder_times,
  [IconName.full_name]: full_name,
  [IconName.globe]: globe,
  [IconName.googles]: googles,
  [IconName.grid]: grid,
  [IconName.heart_outlined]: heart_outlined,
  [IconName.heartbeat]: heartbeat,
  [IconName.horizontal_barchart]: horizontal_barchart,
  [IconName.key_horizontal]: key_horizontal,
  [IconName.key_vertical]: key_vertical,
  [IconName.keyboard]: keyboard,
  [IconName.lamp]: lamp,
  [IconName.layout]: layout,
  [IconName.link]: link,
  [IconName.list]: list,
  [IconName.lock]: lock,
  [IconName.lock_opened]: lock_opened,
  [IconName.magic_wand]: magic_wand,
  [IconName.mail]: mail,
  [IconName.menu]: menu,
  [IconName.microscope]: microscope,
  [IconName.minus]: minus,
  [IconName.multi_select]: multi_select,
  [IconName.network]: network,
  [IconName.newsroom]: newsroom,
  [IconName.notebook]: notebook,
  [IconName.notebook_arrow_up]: notebook_arrow_up,
  [IconName.panes_horizontal]: panes_horizontal,
  [IconName.panes_vertical]: panes_vertical,
  [IconName.paper_plane]: paper_plane,
  [IconName.paragraph]: paragraph,
  [IconName.pause]: pause,
  [IconName.pencil]: pencil,
  [IconName.pencil_check]: pencil_check,
  [IconName.picture]: picture,
  [IconName.picture_light]: picture_light,
  [IconName.pictures]: pictures,
  [IconName.pie_chart]: pie_chart,
  [IconName.pin]: pin,
  [IconName.pin_outlined]: pin_outlined,
  [IconName.planet]: planet,
  [IconName.play]: play,
  [IconName.plug_connecting]: plug_connecting,
  [IconName.plugin]: plugin,
  [IconName.plus]: plus,
  [IconName.poll]: poll,
  [IconName.preview]: preview,
  [IconName.preview2]: preview2,
  [IconName.puzzle_piece]: puzzle_piece,
  [IconName.radio_btn]: radio_btn,
  [IconName.refresh]: refresh,
  [IconName.repeat]: repeat,
  [IconName.reply]: reply,
  [IconName.reverse]: reverse,
  [IconName.rhombus]: rhombus,
  [IconName.rocket]: rocket,
  [IconName.rows]: rows,
  [IconName.save]: save,
  [IconName.screen_stats]: screen_stats,
  [IconName.search]: search,
  [IconName.search_eye]: search_eye,
  [IconName.search_left]: search_left,
  [IconName.separator]: separator,
  [IconName.settings]: settings,
  [IconName.share]: share,
  [IconName.sidebar]: sidebar,
  [IconName.slider]: slider,
  [IconName.socket]: socket,
  [IconName.sort_descending]: sort_descending,
  [IconName.spinner]: spinner,
  [IconName.square_arrow_down_to_line]: square_arrow_down_to_line,
  [IconName.square_arrows]: square_arrows,
  [IconName.square_chevron_down]: square_chevron_down,
  [IconName.square_chevron_up]: square_chevron_up,
  [IconName.square_code]: square_code,
  [IconName.square_exclamation]: square_exclamation,
  [IconName.square_hash]: square_hash,
  [IconName.square_info]: square_info,
  [IconName.square_lego]: square_lego,
  [IconName.square_markdown]: square_markdown,
  [IconName.square_minus]: square_minus,
  [IconName.square_number]: square_number,
  [IconName.square_play]: square_play,
  [IconName.square_plus]: square_plus,
  [IconName.square_restart]: square_restart,
  [IconName.square_run_all]: square_run_all,
  [IconName.square_save]: square_save,
  [IconName.square_stop]: square_stop,
  [IconName.square_text]: square_text,
  [IconName.square_times]: square_times,
  [IconName.stacked_areachart]: stacked_areachart,
  [IconName.star_outlined]: star_outlined,
  [IconName.stop]: stop,
  [IconName.target]: target,
  [IconName.tag]: tag,
  [IconName.telescope]: telescope,
  [IconName.text_input]: text_input,
  [IconName.thumb_down]: thumb_down,
  [IconName.thumb_up]: thumb_up,
  [IconName.times]: times,
  [IconName.times_small]: times_small,
  [IconName.trash]: trash,
  [IconName.tray]: tray,
  [IconName.tray_full]: tray_full,
  [IconName.triple_dots]: triple_dots,
  [IconName.user]: user,
  [IconName.user_arrow_left]: user_arrow_left,
  [IconName.user_arrow_right]: user_arrow_right,
  [IconName.user_check]: user_check,
  [IconName.user_cog]: user_cog,
  [IconName.user_plus]: user_plus,
  [IconName.user_search]: user_search,
  [IconName.user_star]: user_star,
  [IconName.user_times]: user_times,
  [IconName.users]: users,
  [IconName.users_v2]: users_v2,
  [IconName.wallet]: wallet,
}
